var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2612_555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 13.4999C5.53526 11.8872 3.54881 10.8427 1.39002 10.5499C1.1443 10.5227 0.917361 10.4054 0.753003 10.2208C0.588645 10.0361 0.498519 9.79709 0.500018 9.54988V1.49988C0.500009 1.35544 0.53129 1.21271 0.59171 1.08151C0.652129 0.950317 0.740253 0.833766 0.850018 0.739879C0.95785 0.6477 1.08406 0.579519 1.22027 0.539864C1.35647 0.500209 1.49956 0.489988 1.64002 0.509879C3.70431 0.852486 5.59274 1.88126 7.00002 3.42988V13.4999Z",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.4999C8.46476 11.8872 10.4512 10.8427 12.61 10.5499C12.8557 10.5227 13.0827 10.4054 13.247 10.2208C13.4114 10.0361 13.5015 9.79709 13.5 9.54988V1.49988C13.5 1.35544 13.4687 1.21271 13.4083 1.08151C13.3479 0.950317 13.2598 0.833766 13.15 0.739879C13.0422 0.6477 12.916 0.579519 12.7798 0.539864C12.6435 0.500209 12.5005 0.489988 12.36 0.509879C10.2957 0.852486 8.40728 1.88126 7 3.42988V13.4999Z",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2612_555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBook);
export default __webpack_public_path__ + "static/media/open_book.febc2f1a3db44b22c7e77af0d0efda7e.svg";
export { ForwardRef as ReactComponent };